import styled from 'styled-components';
import contactUsBanner from 'assets/images/contact-us.jpg';

export const ContactUsContainer = styled.div`
    margin-top: 70px;
`;

export const ContactUsTitle = styled.h1`
    font-family: 'Poppins';
    font-weight: 700;
    font-size: 48px;
    line-height: 72px;
    color: #0e4574;
    margin: 40px 0;
    text-align: center;
`;

export const ContactUsForm = styled.div`
    max-width: 800px;
    width: 100%;
    margin: 0 auto;
    margin-top: 50px;
    margin-bottom: 50px;
`;

export const ContactUsInputContainer = styled.div`
    padding: 6px 16px;
    background: #e0e0e080;
    display: flex;
    align-items: center;
    border-radius: 4px;
    margin-bottom: 8px;
`;

export const ContactUsInput = styled.input`
    background: transparent;
    width: fit-content;
    font-family: 'Poppins';
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #e0e0e0;
    outline: none;
    flex: 1;
    border: none;
`;

export const ContactUsSpan = styled.span`
    font-family: 'Poppins';
    font-weight: 700;
    font-size: 12px;
    line-height: 18px;
    color: #0e4574;
    margin-right: 5px;
`;

export const ContactUsBannerContainer = styled.div`
    background: linear-gradient(
        180deg,
        transparent 35%,
        #ffffff 0%,
        #f7f7f7 0%,
        #d9d9d9 100%
    );
    padding: 100px 0;
`;

export const ContactUsBannerContent = styled.div`
    background: linear-gradient(180deg, rgba(31, 31, 31, 0.56) 0%, rgba(31, 31, 31, 0.16) 100%), url(${contactUsBanner}), lightgray 50% / cover no-repeat;
    box-shadow: 8px 8px 35px 0px rgba(0, 0, 0, 0.10);
    background-position: center right;
    max-width: 1200px;
    width: 100%;
    height: 400px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border-radius: 20px;
`;

export const ContactUsBannerText = styled.div`
    // temporary
    color: var(--White, #FFF);
    text-align: center;
    font-family: Poppins;
    font-size: 25px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`;

export const ContactUsBannerTitle = styled.h3`
    font-family: Poppins;
    font-size: 25px;
    font-weight: 400;
    line-height: 38px;
    color: white;
    width: 45%;
`;

export const ContactUsBannerButton = styled.button`
    margin-top: 35px;
    padding: 8px 20px;
    background: rgba(31, 31, 31, 0.3);
    border: 1px solid #a3c202;
    color: #a3c202;
    border-radius: 8px;
    font-family: 'Poppins';
    font-weight: 700;
    cursor: pointer;
`;
